import blackberryLemonadeSrc from "../../../images/2025/blackberry-lemonade.png";
import strawberryLemonadeSrc from "../../../images/2025/strawberry-lemonade.png";
import whiteLightninLemonadeSrc from "../../../images/2025/white-lightnin-lemonade.png";

export const slides = [
  {
    id: 1,
    label: "Blackberry Lemonade",
    imageSrc: blackberryLemonadeSrc,
    ingredients: [
      {
        id: 1,
        text: "2 oz. Ole Smoky® Blackberry Moonshine",
      },
      {
        id: 2,
        text: "3 oz. Lemonade",
      },
      {
        id: 3,
        text: "Mint",
      },
    ],
    garnish: [
      {
        id: 1,
        text: "Fresh lemon slice",
      },
      {
        id: 2,
        text: "Fresh blackberries (optional)",
      },
    ],
    directions: [
      {
        id: 1,
        text: "Muddle the mint in the bottom of the glass",
      },
      {
        id: 2,
        text: "Add ingredients over ice and mix well",
      },
      {
        id: 3,
        text: "Garnish with lemon slice and blackberries",
      },
    ],
  },
  {
    id: 2,
    label: "Strawberry Lemonade",
    imageSrc: strawberryLemonadeSrc,
    ingredients: [
      {
        id: 1,
        text: "2 oz. Ole Smoky® Strawberry Moonshine",
      },
      {
        id: 2,
        text: "3 oz. Fresh Squeezed Lemonade",
      },
    ],
    garnish: [
      {
        id: 1,
        text: "Fresh Strawberries",
      },
      {
        id: 2,
        text: "Fresh Lemon Wedge",
      },
    ],
    directions: [
      {
        id: 1,
        text: "Mix well in glass over ice",
      },
      {
        id: 2,
        text: "Garnish",
      },
      {
        id: 3,
        text: "Shine Responsibly",
      },
    ],
  },
  {
    id: 3,
    label: "White Lightnin' Lemonade",
    imageSrc: whiteLightninLemonadeSrc,
    ingredients: [
      {
        id: 1,
        text: "Lightnin' Lemonade",
      },
      {
        id: 2,
        text: "1.5 oz. Ole Smoky® White Lightnin’",
      },
      {
        id: 3,
        text: "3 oz. Lemonade",
      },
      {
        id: 4,
        text: "Fresh Lemon Wedge",
      },
    ],
    garnish: [
      {
        id: 1,
        text: "Fresh Lemon Wedge",
      },
    ],
    directions: [
      {
        id: 1,
        text: "Mix well in glass over ice",
      },
      {
        id: 2,
        text: "Garnish",
      },
      {
        id: 3,
        text: "Shine Responsibly",
      },
    ],
  },
];

export const sliderSettings = {
  dots: false,
  arrows: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};
